module.exports = __webpack_public_path__ + "static/img/opn_title.5829bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/daas_case/opn_title.png
// module id = D7aJ
// module chunks = 0